import { UserRoles } from 'apps/orion/src/app/features/scm/material-management/v1/types';
import { AuthenticationStateModel } from './authentication.types';

export const LAST_LOGGED_IN_PRIMARY_SID_KEY = 'lastLoggedInPrimarySid';
export const LAST_URL_BEFORE_LOGOUT_KEY = 'lastUrlBeforeLogout';

export const defaultState: AuthenticationStateModel = {
  activeTenant: '',
  applicationForm: {
    dirty: false,
    errors: {},
    model: undefined,
    status: '',
  },
  commitsModuleRights: {
    cancelCommits: false,
    createCommits: false,
    deleteCommits: false,
    deletePLO: false,
    documentsCreate: false,
    documentsDelete: false,
    documentsView: false,
    downloadExcel: false,
    layoutChanges: false,
    massChanges: false,
    searchCommits: false,
  },
  currentRole: '',
  currentRoles: [],
  isAppReady: false,
  isLoggedIn: false,
  loading: true,
  plant: '',
  plants: [],
  primarySid: '',
  supplyVisibilityRights: {
    cancelCommits: false,
    commentsEdit: false,
    commentsView: false,
    commitsLayout: false,
    deleteCommits: false,
    dummyCommits: false,
    forecastView: false,
    graphsView: false,
    manageCommits: false, //TODO remove dependency
    masterDataView: false,
    notesEdit: false,
    notesView: false,
    reviewFlags: false,
  },
  tenants: [],
  token: '',
  upn: '',
  username: '',
};

export const rolesList: UserRoles[] = Object.values(UserRoles);

const logisticsCoreRoles = [
  UserRoles.Orion_Logistics_Logistic,
  UserRoles.Orion_Logistics_Analyst,
  UserRoles.Orion_Logistics_Carrier,
] as const satisfies UserRoles[];

const adminAndWarehouseAnalysts = [
  UserRoles.Orion_Administrator,
  UserRoles.Orion_Warehouse_Analyst,
] as const satisfies UserRoles[];

const warehouseRoles = [
  UserRoles.Orion_Logistics_Warehouse,
  UserRoles.Orion_Warehouse_Analyst,
] as const satisfies UserRoles[];

export const restrictedFinancialMenuRoles: readonly UserRoles[] = [
  UserRoles.Orion_SCM_Engineering,
  UserRoles.Orion_Logistics_Logistic,
  UserRoles.Orion_Logistics_Analyst,
  UserRoles.Orion_Logistics_Carrier,
  UserRoles.Orion_Logistics_Warehouse,
  UserRoles.Orion_Logistics_Declarant,
  UserRoles.Orion_Logistics_Readonly,
  UserRoles.Orion_Logistics_Slot,
  UserRoles.Orion_Warehouse_Analyst,
];

export const financialRestrictedMenuItems: readonly string[] = [
  'Invoicing',
  'Goods Receipts',
  'Invoice Reconciliation',
];

export const logisticsInstructionAccessibleRoles: readonly UserRoles[] = [
  UserRoles.Orion_Administrator,
  ...logisticsCoreRoles,
];

export const logisticsDocsAccessibleRoles: readonly UserRoles[] = [
  ...logisticsInstructionAccessibleRoles,
];

export const dashboardRoles: readonly UserRoles[] = [
  UserRoles.Orion_SCM_Analyst,
  UserRoles.Orion_SCM_Buyer,
  UserRoles.Orion_SCM_Master_Buyer,
  UserRoles.Orion_Administrator,
  UserRoles.Orion_Logistics_Logistic,
  UserRoles.Orion_Logistics_Analyst,
  UserRoles.Orion_Warehouse_Analyst,
];

export const slotStorageRoles: readonly UserRoles[] = [
  UserRoles.Orion_Administrator,
  UserRoles.Orion_Warehouse_Analyst,
  UserRoles.Orion_Logistics_Slot,
];

export const slotRoles: readonly UserRoles[] = [
  ...slotStorageRoles,
  UserRoles.Orion_Logistics_Analyst,
  UserRoles.Orion_Logistics_Logistic,
  UserRoles.Orion_Logistics_Carrier,
  UserRoles.Orion_Logistics_Declarant,
  UserRoles.Orion_Logistics_Readonly,
];

export const carriersStorageRoles: readonly UserRoles[] = [
  ...adminAndWarehouseAnalysts,
  UserRoles.Orion_Logistics_Slot,
];

export const portfolioRoles: readonly UserRoles[] = [
  UserRoles.Orion_Administrator,
  UserRoles.Orion_Logistics_Analyst,
  UserRoles.Orion_Logistics_Logistic,
  UserRoles.Orion_Warehouse_Analyst,
  UserRoles.Orion_Logistics_Slot,
];
